module.exports = __webpack_public_path__ + "static/media/innovation.8f794ab6.png";